import { NflTeam } from './team';

export class NflPlayoffTeam {
  Team: NflTeam;
  Seed: number;
  /**
   * Display name with seed superscript. Use this instead of mutating Team.TeamName.
   * e.g. "Chiefs <sup>1</sup>"
   */
  TeamDisplayName: string;

  constructor(data: { Team: any; Seed: number }) {
    const team = data.Team;
    this.Team = new NflTeam(
      team.TeamAbbreviation,
      team.RegionName,
      team.TeamName,
      team.Conference,
      team.Division,
      team.TeamID,
      1,
      team.TeamLogo
    );
    this.Seed = data.Seed;
    this.TeamDisplayName = `${team.TeamName} <sup>${data.Seed}</sup>`;
  }
}
